import { I18n } from '@calendly/i18n';
import { FilterMenuButton } from '@calendly/ui/components/filter-menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FilterMenuCountBadge, FilterMenuTriggerIcon } from 'components/cui_filter_menu';
const filterIconContainerCss = "f1acx723";
const FilterIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(filterIconContainerCss, props.className)} />;
});
const triggerLabelGapCss = "t1kxz0hj";
const TriggerLabel = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(triggerLabelGapCss, props.className)} />);
export const FilterButton = forwardRef(({
  appliedFiltersCount
}, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <FilterMenuButton ref={ref} hasSelection={appliedFiltersCount > 0} aria-label="filter-button" data-calendly-label="filter-button" disableArrow>
      <TriggerLabel>
        <FilterIconContainer>
          <FilterMenuTriggerIcon selected={appliedFiltersCount > 0} />
        </FilterIconContainer>
        {isTabletUp && I18n.t('publisher.event_types.filter')}
        <FilterMenuCountBadge count={appliedFiltersCount} />
      </TriggerLabel>
    </FilterMenuButton>;
});

require("./filter_button.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");